import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { ClientSideListBaseComponent } from 'src/app/common/core/client-side-list-base/client-side-list-base.component';
import { AlertDetailsEnum } from 'src/app/common/enums/Tasks.enum';
import { IAlertHeaderConfig } from 'src/app/common/interfaces/home/tasks.interface';
import { columnDefinitionSidePanelTableData } from './side-panel-table-data.config';
import { Router } from '@angular/router';
import { PanelData } from 'src/app/common/interfaces/home/side-panel-details.interface';

@Component({
  selector: 'app-side-panel-table-data',
  standalone: true,
  imports: [
    ClientSideListBaseComponent,
    CommonModule
  ],
  templateUrl: './side-panel-table-data.component.html',
  styleUrls: ['./side-panel-table-data.component.scss']
})
export class SidePanelTableDataComponent {
  columnDefs!: any;
  @Input() rowData: PanelData[] | undefined = []
  @Input() headerDetails: Partial<Record<AlertDetailsEnum, IAlertHeaderConfig>> | undefined;

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges){
    if(changes["headerDetails"].currentValue)
      this.columnDefs = columnDefinitionSidePanelTableData(this);
  }

  navigate(row: PanelData) {
    if(row?.route){
      // Routes into the new React app live outside the Angular router.
      if (row.route.startsWith("/rc/")) {
        window.location.href = row.route;
        return;
      }
      this.router.navigateByUrl(row.route);
    }
  }
}
